<template>
    <!-- BEGIN FOOTER -->
    <div class="footer-wrapper">
        <div class="footer-section f-section-1">
            <p class="">Copyright © {{ anioActual }} Círculo Deportivo Internacional. Todos los derechos reservados.</p>
        </div>
        <div class="footer-section f-section-2">
            <p class="">developed by <a href="mailto:mike.romero21@outlook.com">MR</a></p>
        </div>
    </div>
    <!-- END FOOTER -->
</template>

<script setup>
    const anioActual = new Date().getFullYear();
</script>
